"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));
var _templateObject;
var CalloutQuoteStyles = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n .quote {\n    font-weight: 600;\n    font-family: var(--bf-lead-font);\n    font-style: italic;\n    font-size: 30px;\n    line-height: 133%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    color: var(--bf-core-teal);\n    padding-left: 75px;\n    padding-right: 75px;\n }\n\n .caption {\n    font-weight: 400;\n    font-family: var(--bf-lead-font);\n    font-size: 20px;\n    line-height: 200%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    color: var(--bf-core-gray);\n    padding-bottom: 40px; \n    padding-top: 20px; \n }\n\n"])));
var CalloutQuote = function CalloutQuote(_ref) {
  var caption = _ref.caption,
    text = _ref.text,
    children = _ref.children;
  return _react.default.createElement("div", null, _react.default.createElement(CalloutQuoteStyles, null, _react.default.createElement("div", {
    className: "quote"
  }, text), _react.default.createElement("div", {
    className: "caption"
  }, caption)));
};
var _default = CalloutQuote;
exports.default = _default;